// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import productDescriptionVariantStyles from "@rpsc/App/SharedStyles/ProductDescriptionStyles";
import { partNumberAndAttributeStyles } from "@rpsc/App/WidgetExtensions/ProductList/ProductListProductCardExtensions";
import { productGridCardStyles } from "@rpsc/Overrides/Widgets/ProductList/ProductListProductGridCard";
import { fontConfig } from "@rpsc/XDL/PreStyle/typography";
import { color, mergeWithCss, xScreen } from "@rpsc/XDL/Utilities";
import { css } from "styled-components";

productGridCardStyles.productGridContainerStyles = {
    container: {
        css: css`
            max-width: 317px;
            padding: 7px;
            border: 1px solid ${color("common.border")};
            border-radius: 4px;

            ${xScreen("gt", "xl")} {
                max-width: 376px;
            }
        `,
    },
};

productGridCardStyles.productPriceAndActionsStyles = {
    productGridContainer: {
        container: {
            css: css`
                margin-top: auto;
                &.pricing-info-container {
                    margin-top: 50px;
                    margin-bottom: 12px;
                }
                &:empty {
                    display: none;
                }
            `,
        },
    },
};

productGridCardStyles.productListImageStyles = {
    wrapper: {
        css: css`
            position: relative;
            margin-bottom: 12px;
        `,
    },
    compareCheckbox: {
        css: css`
            margin: 0;
            padding: 0;
        `,
    },
    productImage: {
        linkWrappingImage: {
            css: css`
                height: 301px;
                position: relative;
                width: 100%;
                ${xScreen("gt", "xl")} {
                    height: 360px;
                }
            `,
        },
        img: {
            width: 301,
            height: 301,
            css: css`
                max-width: 100%;
                max-height: 100%;
                height: auto;
            `,
        },
    },
};

productGridCardStyles.productInformationStyles = {
    attributes: {
        container: {
            offsetCss: css`
                gap: 8px;
                margin-bottom: 8px;
            `,
        },
        attributeTypeGridItem: {
            ...partNumberAndAttributeStyles,
        },
        attributeValueGridItem: {
            ...partNumberAndAttributeStyles,
        },
        attributeTypeText: {
            size: 12,
            lineHeight: "14px",
            weight: fontConfig.weight.bold,
        },
        attributeValueText: {
            size: 12,
            lineHeight: "14px",
            color: "common.ui5",
        },
    },
    descriptionStyles: {
        ...mergeWithCss(productDescriptionVariantStyles.medium, {
            productDetailLink: {
                css: css`
                    min-height: 32px;
                `,
            },
        }),
    },
};
